import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { baseTheme as defaultTheme } from '@infl-ts/ui-advocate-theme';
import { DE$ } from '@infl-ts/util-datum';
import { ClearedLens, LensContext } from '@infl-ts/util-lens';
import { useHubApi } from '@infl-ts/util-use-hub-api';
import { Box, createTheme, Divider, styled, ThemeProvider as MuiThemeProvider, Typography, useMediaQuery } from '@mui/material';
import * as A from 'fp-ts/Array';
import { constFalse, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Str from 'fp-ts/string';
import * as t from 'io-ts';
import { useContext } from 'react';
import ContextSwitcher from './context-switcher';
import LensLoader from './lenses/lens-loader';
import LensLabel from './lenses/lens-loader/lens-label';
import NotificationBar from './lenses/notification-bar';
import RewriteDisableButton from './rewrite-disable-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var MemberViewLabel = function MemberViewLabel() {
  return /*#__PURE__*/_jsx(Typography, {
    sx: {
      color: 'neutral.contrastText',
      whiteSpace: 'nowrap',
      mr: 2
    },
    "data-element": "Typography",
    "data-component": "MemberViewLabel",
    "data-source-file": "admin-bar.tsx",
    children: "Member View"
  });
};

var BaseBar = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding: ", ";\n  position: relative;\n  z-index: ", ";\n"])), function (p) {
  return p.theme.palette.neutral.main;
}, function (p) {
  return p.theme.spacing(1, 2);
}, function (p) {
  return p.theme.zIndex.lensBar;
});

var AdminBarContainer = function AdminBarContainer(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? /*#__PURE__*/_jsx(MemberViewLabel, {}) : _ref$children;
  return /*#__PURE__*/_jsx(BaseBar, {
    "data-element": "BaseBar",
    "data-component": "AdminBarContainer",
    "data-source-file": "admin-bar.tsx",
    children: children
  });
};

export var PureAdminBar = function PureAdminBar(_ref2) {
  var lens = _ref2.lens,
      hasCorporateAccess = _ref2.hasCorporateAccess,
      _ref2$showRewriteDisa = _ref2.showRewriteDisableButton,
      showRewriteDisableButton = _ref2$showRewriteDisa === void 0 ? false : _ref2$showRewriteDisa;
  var isTablet = useMediaQuery(function (theme) {
    return theme.breakpoints.down('lg');
  });
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  return /*#__PURE__*/_jsxs(MuiThemeProvider, {
    theme: createTheme(defaultTheme),
    "data-element": "MuiThemeProvider",
    "data-component": "PureAdminBar",
    "data-source-file": "admin-bar.tsx",
    children: [/*#__PURE__*/_jsx(AdminBarContainer, {
      "data-element": "AdminBarContainer",
      "data-component": "PureAdminBar",
      "data-source-file": "admin-bar.tsx",
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          width: 1,
          alignItems: 'center',
          flexDirection: {
            xs: 'column',
            lg: 'row'
          }
        },
        "data-element": "Box",
        "data-component": "PureAdminBar",
        "data-source-file": "admin-bar.tsx",
        children: [isTablet ? /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            width: 1
          },
          children: [/*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              width: 1,
              alignItems: 'center'
            },
            children: [/*#__PURE__*/_jsx(MemberViewLabel, {}), (lens === null || lens === void 0 ? void 0 : lens.current) && /*#__PURE__*/_jsx(LensLabel, {
              lens: lens === null || lens === void 0 ? void 0 : lens.current,
              isMobile: isMobile
            })]
          }), showRewriteDisableButton && /*#__PURE__*/_jsx(Box, {
            sx: {
              mb: 0.5,
              minWidth: 'fit-content'
            },
            children: /*#__PURE__*/_jsx(RewriteDisableButton, {})
          }), hasCorporateAccess && /*#__PURE__*/_jsx(ContextSwitcher, {})]
        }) : /*#__PURE__*/_jsx(MemberViewLabel, {}), lens && /*#__PURE__*/_jsx(Box, {
          sx: {
            width: 1
          },
          children: /*#__PURE__*/_jsx(LensLoader, {
            lens: lens.current,
            lensActionPending: lens.lensActionPending,
            actions: lens.actions,
            group: lens.group,
            setGroup: lens.setGroup,
            individual: lens.individual,
            setIndividual: lens.setIndividual,
            hasCorporateAccess: hasCorporateAccess
          })
        }), showRewriteDisableButton && !isTablet && /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            width: 1,
            justifyContent: 'flex-end'
          },
          children: [/*#__PURE__*/_jsx(RewriteDisableButton, {}), /*#__PURE__*/_jsx(Divider, {
            orientation: "vertical",
            flexItem: true,
            sx: {
              ml: 2,
              my: -1
            }
          })]
        }), !isTablet && hasCorporateAccess && /*#__PURE__*/_jsx(ContextSwitcher, {})]
      })
    }), (lens === null || lens === void 0 ? void 0 : lens.current) && !ClearedLens.is(lens.current) && /*#__PURE__*/_jsx(NotificationBar, {
      lens: lens.current,
      actions: lens.actions
    })]
  });
};
var strArrElem = A.elem(Str.Eq);
var Features = t.type({
  data: t.array(t.string)
});

var AdminBar = function AdminBar(_ref3) {
  var hasCorporateAccess = _ref3.hasCorporateAccess,
      canViewLenses = _ref3.canViewLenses;
  var lens = useContext(LensContext);
  var showRewriteDisableButton = pipe(useHubApi({
    url: '/api/features/public',
    method: 'get',
    outputCodec: Features
  }), DE$.successToOption, O.map(function (x) {
    return x.data;
  }), O.match(constFalse, strArrElem('rewrite_toggle_button')));
  return /*#__PURE__*/_jsx(PureAdminBar, {
    lens: canViewLenses ? lens : null,
    hasCorporateAccess: hasCorporateAccess,
    showRewriteDisableButton: showRewriteDisableButton,
    "data-element": "PureAdminBar",
    "data-component": "AdminBar",
    "data-source-file": "admin-bar.tsx"
  });
};

export default AdminBar;